// Banner Rotation — uses requestAnimationFrame and gsap
window.addEventListener('load', function () {
    const ROTATION_INTERVAL_MS = 60000;
    const posClasses = ['banner-pos-left', 'banner-pos-right', 'banner-pos-hidden'];
    let currentIndex = 0;
    let lastRotationTime = 0;

    function getElements() {
        return {
            banners: [
                document.getElementById('banner-1'),
                document.getElementById('banner-2'),
                document.getElementById('banner-3')
            ],
            slots: [
                document.getElementById('banner-slot-left'),
                document.getElementById('banner-slot-right'),
                document.getElementById('banner-slot-hidden')
            ]
        };
    }

    function createBlinds(slot) {
        const blinds = document.createElement('div');
        blinds.className = 'blinds-container';
        for (let i = 0; i < 10; i++) {
            const strip = document.createElement('div');
            strip.className = 'blinds-strip';
            blinds.appendChild(strip);
        }
        slot.appendChild(blinds);
        return blinds;
    }

    function rotate() {
        try {
            const { banners, slots } = getElements();

            if (banners.some(b => !b) || slots.some(s => !s)) {
                return;
            }

            // Create blinds for the primary slots (left and right)
            const activeSlots = [slots[0], slots[1]]; // banner-slot-left and banner-slot-right
            const blindsContainers = activeSlots.map(createBlinds);

            // GSAP Timeline for the blinds effect
            const tl = gsap.timeline({
                onComplete: () => {
                    blindsContainers.forEach(bc => bc.remove());
                }
            });

            // 1. Close blinds
            tl.to(blindsContainers.flatMap(bc => Array.from(bc.children)), {
                scaleX: 1,
                duration: 0.4,
                stagger: 0.03,
                ease: "power2.inOut"
            });

            // 2. Midpoint: Swap banners (behind the blinds)
            tl.add(() => {
                currentIndex = (currentIndex + 1) % 3;

                const mapping = [
                    [0, 1, 2], // T0: B1-L, B2-R, B3-H
                    [2, 0, 1], // T1: B3-L, B1-R, B2-H
                    [1, 2, 0]  // T2: B2-L, B3-R, B1-H
                ][currentIndex];

                mapping.forEach((bannerIdx, slotIdx) => {
                    const banner = banners[bannerIdx];
                    const slot = slots[slotIdx];

                    if (banner && slot) {
                        if (banner.parentElement !== slot) {
                            slot.appendChild(banner);
                        }

                        posClasses.forEach(cls => {
                            if (cls !== posClasses[slotIdx]) {
                                banner.classList.remove(cls);
                            }
                        });
                        if (!banner.classList.contains(posClasses[slotIdx])) {
                            banner.classList.add(posClasses[slotIdx]);
                        }
                    }
                });
            });

            // 3. Open blinds
            tl.to(blindsContainers.flatMap(bc => Array.from(bc.children)), {
                scaleX: 0,
                transformOrigin: "right",
                duration: 0.4,
                stagger: 0.03,
                ease: "power2.inOut"
            });

        } catch (error) {
            if (__LOG_ERROR__) AppLog.error('[BannerRotation] Error:', error);
        }
    }

    function tick(timestamp) {
        if (timestamp - lastRotationTime >= ROTATION_INTERVAL_MS) {
            lastRotationTime = timestamp;
            rotate();
        }
        requestAnimationFrame(tick);
    }

    const { banners, slots } = getElements();
    if (banners.every(b => b) && slots.every(s => s)) {
        requestAnimationFrame(tick);
    }
    
    
    // part 2
    // Watchlist Banner Button
    const toWatchlistBannerBtn = document.getElementById('to-watchlist-btn');
    if (toWatchlistBannerBtn) {
        toWatchlistBannerBtn.addEventListener('click', () => {
            if (window.consentGiven === false) {
                if (window.AuthUI && window.AuthUI.showMessage) {
                    window.AuthUI.showMessage('Login restricted. You cannot login until you accept the cookies');
                }
                return;
            }
            if (window.WatchlistApp && window.WatchlistApp.Manager) {
                window.WatchlistApp.Manager.enterWatchlistMode();

                // Switch filter to watchlist if user is authorized
                const access = window.WatchlistApp.Manager.checkWatchlistAccess();
                if (access.allowed) {
                    const watchlistFilterBtn = document.querySelector('.filters-container .item[data-action="watchlist-reports"]');
                    if (watchlistFilterBtn) {
                        watchlistFilterBtn.click();
                    }
                }
            }
        });
    }
});
